// Applique de la css à un élément
const css = (element, style) => {
  Object.assign(element.style, style);
}

export { css };
